import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Guide from "@/pages/Guide";
import Team from "@/pages/Team";
import History from "@/pages/History";
import Clients from "@/pages/Clients";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import Activity from "@/pages/Activity";
import Finance from "@/pages/Finance";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";

const Protected = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 text-emerald-500 animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const LoginRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" replace /> : <Login />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Dashboard />
                </Protected>
              }
            />
            <Route
              path="/guide"
              element={
                <Protected>
                  <Guide />
                </Protected>
              }
            />
            <Route
              path="/equipe"
              element={
                <Protected>
                  <Team />
                </Protected>
              }
            />
            <Route
              path="/clients"
              element={
                <Protected roles={["admin"]}>
                  <Clients />
                </Protected>
              }
            />
            <Route
              path="/historique"
              element={
                <Protected roles={["admin"]}>
                  <History />
                </Protected>
              }
            />
            <Route
              path="/admin"
              element={
                <Protected roles={["admin"]}>
                  <Admin />
                </Protected>
              }
            />
            <Route
              path="/compte"
              element={
                <Protected>
                  <Account />
                </Protected>
              }
            />
            <Route
              path="/activite"
              element={
                <Protected roles={["admin"]}>
                  <Activity />
                </Protected>
              }
            />
            <Route
              path="/finances"
              element={
                <Protected roles={["admin"]}>
                  <Finance />
                </Protected>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
